import { TaskIdentifiers } from '../constants/stock';
import { AppointmentInterface } from '../types/appointment';
import { TaskType } from '../types/task';

const mainTaskIdentifiers = [
    TaskIdentifiers.APK,
    TaskIdentifiers.TACHOGRAPH,
    TaskIdentifiers.EXAMINATION,
    TaskIdentifiers.SERVICE,
    TaskIdentifiers.TAILGATE,
    TaskIdentifiers.CFK_EXAMINATION,
];

export const getMainTasks = (tasks: TaskType[]) => {
    return tasks.filter(
        (task: TaskType) =>
            task.identifier &&
            mainTaskIdentifiers.includes(task.identifier as TaskIdentifiers)
    );
};

export const removeMainTasks = (tasks: TaskType[]) => {
    return tasks.filter((task) => {
        return task.identifier
            ? !mainTaskIdentifiers.includes(task.identifier as TaskIdentifiers)
            : true;
    });
};

export const hasNonMainTasks = (appointment: AppointmentInterface) => {
    const appointmentTasks = appointment.tasks.map((task) => task.task.id);
    const mainTasks = getMainTasks(appointment.tasks.map((task) => task.task));

    return (
        appointmentTasks.filter(
            (identifier) => !isMainTask(mainTasks, identifier)
        ).length > 0
    );
};

export const isMainTask = (mainTasks: TaskType[], id: number) => {
    const task = Object.values(mainTasks).find((task) => {
        return task.id === id;
    });

    return !!task;
};
